import auth0 from 'auth0-js';
import jwt_decode from 'jwt-decode';
import * as cryptoJS from 'crypto-js';
import { storeVars } from '@archre2/react-core';
import config from '../../config';

const PERMISSION_ATTR_NAME = 'permissions';
const USER_PROFILE_ID = 'http://archway.archre.com/user_profile_id';
const USER_CONNECTION = 'http://archre.com/user_connection';

export const setAuthContext = (cb, navigate) => {
  // const [, rerender] = React.useReducer((c) => c + 1, 0);

  const webAuth = new auth0.WebAuth({
    domain: config.AUTHENTICATION.DOMAIN,
    clientID: config.AUTHENTICATION.CLIENT_ID,
    audience: config.AUTHENTICATION.AUDIENCE,
    redirectUri: config.AUTHENTICATION.CALLBACK_URL,
    responseType: 'token id_token',
    scope: 'openid profile email',
  });

  const encryptKey = '@rchway-123';

  function login(targetPath) {
    const stateNonce = generateNonce(targetPath);
    webAuth.authorize({ nonce: stateNonce });
  }

  function logout() {
    webAuth.logout({ returnTo: config.AUTHENTICATION.LOGOUT_URL });
  }

  function handleAuthentication() {
    webAuth.parseHash({ hash: window.location.hash }, (err, authResult) => {
      let targetURL = '/';
      if (authResult && authResult.accessToken && authResult.idToken) {
        targetURL = getURLFromNonce(extractNonce(authResult.idToken));
        //get user permissions from ID token
        const userPermissions = extractPermissions(authResult.accessToken);
        const { userProfileId, connectionType } = extractUserdetails(
          authResult.idToken
        );

        const session = {
          ...authResult,
          expiresAt: authResult.expiresIn * 1000 + new Date().getTime(),
          scopes: authResult.scope || this.requestedScopes || '',
          userPermissions,
          userProfileId,
          connectionType,
          isCurrentUser: (val) => {
            return val && val.toLowerCase() === userProfileId.toLowerCase();
          },
        };

        storeVars.setSession(session);
        cb && cb(session);
        getProfile(authResult.accessToken, (res) => {
          const updatedSession = {
            ...storeVars.session(),
            userInfo: res,
          };
          storeVars.setSession(updatedSession);
          cb && cb(updatedSession);
        });

        // rerender();
      } else if (err) {
        console.log('invalid user: ', err);
      }
      navigate && navigate(targetURL);
    });
  }

  //Function to extract permissions from ID token by attribute name
  function extractPermissions(accessToken) {
    let decoded = jwt_decode(accessToken);
    return decoded[PERMISSION_ATTR_NAME];
  }

  function extractUserdetails(idToken) {
    let decoded = jwt_decode(idToken);
    return {
      userProfileId: decoded[USER_PROFILE_ID],
      connectionType: decoded[USER_CONNECTION],
    };
  }

  function isAuthenticated() {
    if (storeVars.session()?.expiresAt)
      return new Date().getTime() < storeVars.session().expiresAt;
    return false;
  }

  function generateNonce(sourceURL) {
    return cryptoJS.AES.encrypt(
      JSON.stringify(sourceURL),
      encryptKey
    ).toString();
  }

  function extractNonce(idToken) {
    let decoded = jwt_decode(idToken);

    return decoded.nonce;
  }

  function getURLFromNonce(stateNonce) {
    let bytes = cryptoJS.AES.decrypt(stateNonce, encryptKey);
    return JSON.parse(bytes.toString(cryptoJS.enc.Utf8));
  }

  const getProfile = (accessToken, cb) => {
    webAuth.client.userInfo(accessToken, (err, profile) => {
      cb(profile, err);
    });
  };

  return {
    session: storeVars.session(),
    login,
    logout,
    handleAuthentication,
    isAuthenticated,
    getProfile,
  };
};
